<template>
  <div>
    <div class="header">
      <div class="header-body">
        <div class="header-body-title">绽放工场以业界领先技术为您提供服务</div>
      </div>
      <figure class="bg"></figure>
    </div>
    <div class="body">
      <img class="body-poster" src="https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/technology_details%402x.png" />
    </div>
  </div>
</template>

<script>
export default {
  components: {
  }
}
</script>
<style scoped>
.header {
  text-align: center;
  color: #ffffff;
  height: 560px;
  overflow: hidden;
  position: relative;
}
.header-body {
  max-width: 1200px;
  margin: 230px auto 0;
}
.header-body-title {
  font-size:40px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(250,250,250,1);
}
.header-body-line {
  width:40px;
  height:1px;
  background:rgba(255,255,255,1);
  margin: 22px auto 30px;
}
.header-body-desc {
  font-size:18px;
  color:rgba(255,255,255,1);
}
.bg {
  width: 1920px;
  height: 560px;
  background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/technology_h560px_banner%402x.png');
  background-size: 1920px 560px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
}
.body {
  background-color: #F7FCFC;
  overflow: hidden;
}
.body-poster {
  width: 1920px;
  position: relative;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
}

@media (max-width: 1199px) and (min-width: 992px){
  .body-poster {
    width: calc(1920px * 0.82);
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .body-poster {
    width: calc(1920px * 0.70);
  }
}
@media screen and (max-width: 767px){
  .body-poster {
    width: calc(1920px * 0.60);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/leadingTechnology.vue